var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-spacer'),_c('flowy-drag-handle',[_c('v-btn',{attrs:{"color":"primary","text":""}},[_c('v-icon',[_vm._v("mdi-drag")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }